export default __webpack_public_path__ + "static/sarandi-13f2f841f3cf20e75d1acd98e1fe69c5.jpg";